// extracted by mini-css-extract-plugin
module.exports = {"fab-root":"FAB_fab-root__33zPr"};